"use client"

import { GlassCard } from "@shared/ui/landing/glass-card"
import { SectionContainer } from "@shared/ui/landing/section-container"

import { useTranslations } from "@/lib/i18n/client"

const QUOTE_KEYS = ["quote1", "quote2", "quote3"] as const

export function TestimonialsSection() {
  const t = useTranslations("testimonials")

  return (
    <SectionContainer>
      <div className="mb-10 space-y-3 text-center">
        <h2 className="text-3xl font-bold tracking-tight md:text-4xl">{t("title")}</h2>
        <p className="text-muted-foreground">{t("subtitle")}</p>
      </div>
      <div className="grid gap-4 md:grid-cols-3">
        {QUOTE_KEYS.map((key) => (
          <GlassCard key={key} className="flex flex-col justify-between gap-6">
            <p className="text-sm leading-relaxed text-muted-foreground">
              &ldquo;{t(`${key}.body`)}&rdquo;
            </p>
            <div>
              <p className="font-medium">{t(`${key}.author`)}</p>
              <p className="text-xs text-muted-foreground">{t(`${key}.role`)}</p>
            </div>
          </GlassCard>
        ))}
      </div>
    </SectionContainer>
  )
}
